import { useEffect, useState, VFC } from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { LargeButton } from 'src/elements/Button'
import { Link } from 'src/elements/Link'
import { AuthService } from 'src/services/AuthService'
import {
  _menuhover,
  _message_submenu_subtitle,
  errorRed,
  facebookBlue,
  safetyOrange,
  truewhite,
} from 'src/styles/colors'
import { fontWeightMedium } from 'src/styles/font'
import { flexCenter } from 'src/styles/mixins'
import { FORGOT_PASSWORD } from 'src/utils/routes'
import styled from 'styled-components'
import { FormInput } from '../../Profile/formComponents'
import { FACEBOOK_2 } from 'src/assets/images'

export type SignInFormData = {
  email: string
  password: string
}
export const SignIn: VFC<{
  submit: (data: SignInFormData) => Promise<any>
  hasSocialLoginFailed: boolean
}> = ({ submit, hasSocialLoginFailed }) => {
  const [errorMessage, setErrorMessage] = useState('')
  const methods = useForm<SignInFormData>()
  const {
    handleSubmit,
    formState: { isSubmitting },
  } = methods

  useEffect(() => {
    if (hasSocialLoginFailed)
      setErrorMessage(
        'Facebookアカウントに対応するユーザーが存在しません。メールアドレスでログインしてからアカウント連携を行ってください。',
      )
  }, [hasSocialLoginFailed])
  return (
    <>
      <Content>
        <h1>ONLY STORYにログインする</h1>
        <FacebookLoginButton onClick={AuthService.signInWithFacebook}>
          <ButtonDiv>
            <img src={FACEBOOK_2} alt="icon" />
            <label>Facebookでログイン</label>
          </ButtonDiv>
        </FacebookLoginButton>
        <TextLine>
          <p>または</p>
        </TextLine>
        <FormProvider {...methods}>
          <Form
            onSubmit={handleSubmit((data) =>
              submit(data).catch(setErrorMessage),
            )}
          >
            <FormInput
              id="email"
              label="メールアドレス"
              type="email"
              autoComplete="email"
              optional
              withoutBorder
            />
            <FormInput
              id="password"
              label="パスワード"
              type="password"
              autoComplete="password"
              optional
              withoutBorder
            />
            {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
            <LoginButton disabled={isSubmitting}>ログイン</LoginButton>
          </Form>
        </FormProvider>
        <Links>
          <Link href={FORGOT_PASSWORD}>パスワードを忘れましたか？</Link>
        </Links>
      </Content>
    </>
  )
}

const ErrorMessage = styled.p`
  height: 1.5em;
  color: ${errorRed};
  text-align: center;
  white-space: pre-wrap;
`
const Links = styled.div`
  ${flexCenter};
  flex-direction: column;
  line-height: 1.5;
  color: ${safetyOrange};
  font-size: 12px;
  text-decoration: underline;

  a {
    :hover {
      color: ${_menuhover};
      text-decoration: underline;
    }
  }
`

const FacebookLoginButton = styled.button`
  width: 100%;
  min-height: 40px;
  max-width: 232px;
  padding: 8px;
  border-radius: 5px;
  background-color: ${facebookBlue};
  color: ${truewhite};
  font-size: 14px;
`

const ButtonDiv = styled.div`
  display: flex;
  width: 100%;
  line-height: 24px;
  text-align: center;
  justify-content: space-between;

  img {
    width: 24px;
    height: 24px;
    margin-left: 0px;
  }

  label {
    width: 100%;
    line-height: 24px;
    text-align: center;
    cursor: pointer;
  }
`

const Form = styled.form`
  width: 100%;
`

const TextLine = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${_message_submenu_subtitle};

  p {
    margin: 0 16px;
  }

  :before,
  :after {
    content: '';
    flex-grow: 1;
    height: 1px;
    background: ${_message_submenu_subtitle};
  }
`

const LoginButton = styled(LargeButton)`
  background: ${safetyOrange};
  color: ${truewhite};
  min-width: 225px;
`

const Content = styled.div`
  margin: 10px auto 0px;
  padding: 40px;
  max-width: 520px;
  ${flexCenter};
  flex-direction: column;
  border-radius: 5px;
  box-shadow: 2px 6px 16px 0px rgba(156, 157, 160, 0.8);

  h1 {
    width: 100%;
    text-align: center;
    font-size: 26px;
    font-weight: ${fontWeightMedium};
    margin-bottom: 40px;
  }
  ${FacebookLoginButton} {
    display: block;
    margin: 0px auto 40px;
  }
  ${TextLine} {
    margin-bottom: 10px;
  }
  ${ErrorMessage} {
    margin-top: 24px;
  }
  ${LoginButton} {
    display: block;
    margin: 40px auto 24px;
  }
`
